import React from "react";
import { Button, Box, Typography } from "@mui/material";
import { useGoogleLogin } from "@react-oauth/google";
import GoogleIcon from "../../common/svg/GoogleIcon";
import { googleSignup } from "../api/actions/mutation";

const GoogleSignupButton = ({
  onGoogleStart,
  onGoogleSuccess,
  onGoogleError,
}) => {
  const googleSignupHandler = useGoogleLogin({
    flow: "auth-code",
    scope:
      "openid profile email https://www.googleapis.com/auth/user.phonenumbers.read",
    onSuccess: async (tokenResponse) => {
      onGoogleStart();
      try {
        const code = tokenResponse.code;
        const response = await googleSignup(code);
        
        if (response.data.success) {
          const { name, email, phoneNumber, picture, googleId } = response.data.data;
          onGoogleSuccess({
            name,
            email,
            phoneNumber: phoneNumber ? phoneNumber.replace(/\D/g, "") : "",
            picture,
            googleId,
          });
        } else if(response?.data.data.type ==="EMAIL_EXIST"){
            onGoogleError(response.message);
        } else {
            onGoogleError(response?.message || "Google signup failed.");
        }
      } catch (err) {
        console.error("Google signup failed:", err);
        onGoogleError("Google signup failed. Please try again.");
      }
    },
    onError: (error) => {
      console.error("Google signup failed:", error);
      onGoogleError("Google signup failed. Please try again.");
    },
  });

  return (
    <Button
      fullWidth
      onClick={() => googleSignupHandler()}
      sx={{
        color: "#3C4043",
        borderRadius: "30px",
        py: 1.2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textTransform: "none",
        border: "1px solid #D9D9D9",
        mb: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <GoogleIcon />
        <Typography sx={{ ml: 1, fontSize: "15px" }}>
          Sign up with Google
        </Typography>
      </Box>
    </Button>
  );
};

export default GoogleSignupButton;
